<template>
  <div class="form-group">
    <label
      :for="`input-shopper-custprop-${Guid}-${_uid}`"
      class="col-md-3 control-label"
      :class="{ 'text-red': Recommended && value.length < 1 }"
    >
      {{ Title }}
      <span v-if="Recommended">*</span>
    </label>
    <div class="col-md-9">
      <Select2
        class="form-control"
        :id="`input-shopper-custprop-${Guid}-${_uid}`"
        :allowClear="true"
        :tags="AllowCustomValues"
        :multiple="true"
        :placeholder="' '"
        :disabled="readOnly"
        v-model="Value"
        :afterChange="updateValue"
      >
        <option
          v-for="element in ListValues"
          :key="element.ValueGuid"
          :value="element.ValueGuid"
        >
          {{ element.Value }}
        </option>
      </Select2>
    </div>
  </div>
</template>
<script>
import Select2 from "./../../Tools/Select2";

export default {
  name: "MultiSelectInput",
  components: { Select2 },
  props: {
    Title: String,
    Guid: String,
    ListValues: { type: Array, default: () => [] },
    Recommended: { type: Boolean, default: false },
    AllowCustomValues: { type: Boolean, default: false },
    value: { type: Array, default: () => [] },
    readOnly: { type: Boolean, default: false },
  },
  methods: {
    updateValue(newValue) {
      this.$emit("input", newValue);
    },
  },
  data() {
    return {
      Value: [],
    };
  },
  mounted() {
    this.Value = this.value;
  },
};
</script>



// WEBPACK FOOTER //
// MultiSelectInput.vue?50b4cfb2